import { singleRequest } from "./singleRequest.js";
import { api } from "./framework/api.js";

export const configTables = {
    getStates: getStates,
    getSearchRadiusOptions: getSearchRadiusOptions,
    getSpecialties: getSpecialties,
    getProfessionalDesignations: getProfessionalDesignations,
    getGenders: getGenders,
    getRelationshipsToPrimary: getRelationshipsToPrimary,
    getRelationships: getRelationships,
    getTitles: getTitles,
    getBankAccountTypes: getBankAccountTypes,
    getCompanyTypes: getCompanyTypes,
    getPreventativeCareOptions: getPreventativeCareOptions,
    getProviderAfterHoursOptions: getProviderAfterHoursOptions,
    getPlanLevels: getPlanLevels,
    getPlanCategories: getPlanCategories,
    getLanguages: getLanguages,
    getWhiteLabelOptions: getWhiteLabelOptions,
    getPaymentStrategyTypes: getPaymentStrategyTypes,
    getPaymentTypes: getPaymentTypes,
    getPlanFrequencies: getPlanFrequencies,
    getReferralSurveyOptions: getReferralSurveyOptions,
    getFeeTypes: getFeeTypes,
    getOpenMarketFeeTypes: getOpenMarketFeeTypes,
    getCoverageOptions: getCoverageOptions,
    getSharedPatientsReportColumnMappings: getSharedPatientsReportColumnMappings,
    getPaymentReportColumnMappings: getPaymentReportColumnMappings,
    getDebtReconciliationReportColumnMappings: getDebtReconciliationReportColumnMappings,
    getDebtSettlementsReportColumnMappings: getDebtSettlementsReportColumnMappings,
    getDebtForgivenessReportColumnMappings: getDebtForgivenessReportColumnMappings,
    getPhysicianReportColumnMappings: getPhysicianReportColumnMappings,
    getPatientContractsReportColumnMappings: getPatientContractsReportColumnMappings,
    getAvailablePlansReportColumnMappings: getAvailablePlansReportColumnMappings,
    getConsultantPaymentReportColumnMappings: getConsultantPaymentReportColumnMappings,
    getPayrollDeductionsReportColumnMappings: getPayrollDeductionsReportColumnMappings,
    getConsultantFeesReportColumnMappings: getConsultantFeesReportColumnMappings,
    getConsultantFeePaymentsReportColumnMappings: getConsultantFeePaymentsReportColumnMappings,
    getConsultantMemberSetupReportColumnMappings: getConsultantMemberSetupReportColumnMappings,
    getGroupPaymentReportColumnMappings: getGroupPaymentReportColumnMappings,
    getGroupPayrollDeductionsReportColumnMappings: getGroupPayrollDeductionsReportColumnMappings,
    getGroupFeesReportColumnMappings: getGroupFeesReportColumnMappings,
    getGroupDebtSettlementReportColumnMappings: getGroupDebtSettlementReportColumnMappings,
    getGroupDebtReconcilationReportColumnMappings: getGroupDebtReconcilationReportColumnMappings,
    getGroupMemberSetupReportColumnMappings: getGroupMemberSetupReportColumnMappings,
    getAutoEnrollmentReportColumnMappings: getAutoEnrollmentReportColumnMappings,
    getAdminEmployerContributionPaymentReportColumnMappings: getAdminEmployerContributionPaymentReportColumnMappings,
    getAdminFeesReportColumnMappings: getAdminFeesReportColumnMappings,
    getAdminParticipantsReportColumnMappings: getAdminParticipantsReportColumnMappings,
    getAdminPayrollDeductionsReportColumnMappings: getAdminPayrollDeductionsReportColumnMappings,
    getAdminPhysicianPaymentsReportColumnMappings: getAdminPhysicianPaymentsReportColumnMappings,
    getAdminStackedFeesReportColumnMappings: getAdminStackedFeesReportColumnMappings,
    getAdminNonStackedFeesReportColumnMappings: getAdminNonStackedFeesReportColumnMappings,
    getAdminRetailMembershipReportColumnMappings: getAdminRetailMembershipReportColumnMappings,
    getAdminDebtReconciliationReportColumnMappings: getAdminDebtReconciliationReportColumnMappings,
    getPSRTelescopeDCPPatientsColumnMappings: getPSRTelescopeDCPPatientsColumnMappings,
    getInvoicePaymentReportColumnMappings: getInvoicePaymentReportColumnMappings,
    getFeeBundleReportColumnMappings: getFeeBundleReportColumnMappings,
    getContributionSettlementReportColumnMappings: getContributionSettlementReportColumnMappings,
    getAdminDebtReconciliationContributionReportColumnMappings: getAdminDebtReconciliationContributionReportColumnMappings,
    getAdminPayrollReconciliationReportColumnMappings: getAdminPayrollReconciliationReportColumnMappings,
    getAdminPayrollSettlementReportColumnMappings: getAdminPayrollSettlementReportColumnMappings,
    getAdminGeneratedNachaLineItemReportColumnMappings: getAdminGeneratedNachaLineItemReportColumnMappings,
    getAdminConsumerRefundsReportColumnMappings: getAdminConsumerRefundsReportColumnMappings,
    getGroupParticipantsReportColumnMappings: getGroupParticipantsReportColumnMappings,
    getConsultantReferralReportColumnMappings: getConsultantReferralReportColumnMappings
};

function getStates() {
    return getConfigValues("getStates");
}

function getSearchRadiusOptions() {
    return getConfigValues("getSearchRadius");
}

//By making the function 'async' we keep it consistent with the others, it is faking a promise
async function getGenders() {
    return [{ "genderName": "Male", "genderCode": "M" }, { "genderName": "Female", "genderCode": "F" }, { "genderName": "Unknown", "genderCode": "U" }];
}

async function getRelationshipsToPrimary() {
    return [{ "relationType": "Spouse", "relationshipsEnum": 2 }, { "relationType": "Dependent", "relationshipsEnum": 3 }];
}

function getSpecialties() {
    return getGenericConfigValues("ConfigSpecialty");
}

function getProfessionalDesignations() {
    return getGenericConfigValues("ConfigProfDesignation");
}

function getRelationships() {
    return getGenericConfigValues("ConfigConsumerRelationship");
}

function getTitles() {
    return getGenericConfigValues("ConfigTitle");
}

function getBankAccountTypes() {
    return getGenericConfigValues("ConfigBankAccountType");
}

function getCompanyTypes() {
    return getGenericConfigValues("ConfigCompanyType");
}

function getPreventativeCareOptions() {
    return getGenericConfigValues("ConfigPreventativeCare");
}

function getProviderAfterHoursOptions() {
    return getGenericConfigValues("ConfigProviderAfterHours");
}

function getPlanLevels() {
    return getGenericConfigValues("ConfigPlanLevel");
}

function getPlanCategories() {
    return getGenericConfigValues("ConfigPlanCategories");
}

function getLanguages() {
    return getGenericConfigValues("ConfigLanguage");
}

function getWhiteLabelOptions() {
    return getGenericConfigValues("ConfigWhiteLabel");
}

function getPaymentStrategyTypes() {
    return $.ajax({ type: "GET", url: "utilities/GetPaymentStrategyTypes/" });
}

function getPaymentTypes() {
    return getGenericConfigValues("ConfigPaymentType");
}

function getPlanFrequencies() {
    return getGenericConfigValues("ConfigPlanFrequency");
}

function getReferralSurveyOptions() {
    return getGenericConfigValues("ConfigReferralSurveyOptions");
}

function getFeeTypes(onlyPaidByEmployer) {
    return api.getData('utilities', onlyPaidByEmployer, 'GetFeeTypes');
}

function getOpenMarketFeeTypes() {
    return api.getNoId('utilities', 'GetOpenMarketFeeTypes');
}

async function getCoverageOptions() {
    let coverageTypes = [
        { text: "Primary Only", coverageLevelId: 1 },
        { text: "Primary and Spouse", coverageLevelId: 2 },
        { text: "Primary and Dependents", coverageLevelId: 3 },
        { text: "Primary, Spouse and Dependents", coverageLevelId: 4 }
    ];
    return coverageTypes;
}

function getConfigValues(partialUrl) {
    let ajaxWrapper = function () {
        return $.ajax({ type: "GET", url: "utilities/" + partialUrl });
    };
    let uniqueConfigId = singleRequest.REQUEST_IDENTIFIERS.CONFIG_TABLES + partialUrl;
    return singleRequest.getRequest(uniqueConfigId, ajaxWrapper, true);
}

function getGenericConfigValues(entityName) {
    let ajaxWrapper = function () {
        return $.ajax({ type: "GET", url: "utilities/getConfig/" + entityName });
    };
    let uniqueConfigId = singleRequest.REQUEST_IDENTIFIERS.CONFIG_TABLES + entityName;
    return singleRequest.getRequest(uniqueConfigId, ajaxWrapper, true);
}

function getSharedPatientsReportColumnMappings() {
    return {
        'Patient Full Name': { property: 'fullName' },
        'Dependent of': { property: 'employee' },
        'DOB': {
            property: 'birthDate',
            formatDate: true
        },
        'Gender': { property: 'gender' },
        'Plan Effective Date': {
            property: 'effectiveDate',
            formatDate: true
        },
        'Plan End Date': {
            property: 'endDate',
            formatPlanEndDate: true
        },
        'Plan Selection Date': {
            property: 'selectionDate',
            formatDate: true
        },        
        'Phone Number': {
            property: 'phoneNumber',
            formatPhone: true
        },
        'Email Address': { property: 'emailAddress' },
        'Address': {
            property: 'address',
            formatAddress: true
        },
        'City': { property: 'city' },
        'State': { property: 'stateProvinceCode' },
        'Zip Code': { property: 'zipCode' },
        'Physician': { property: 'physician' },
        'Clinic': { property: 'clinic' },
        'Network': { property: 'network' },
        'Plan Name': { property: 'planName' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Plan Frequency': {property: 'planFrequency'},
        'Group': { property: 'employer' },
        'Patient ID': { property: 'consumerId' },
        'Custom Patient ID': { property: 'customPatientId'
        }
    };
}

function getPaymentReportColumnMappings() {
    return {
        'Physician': { property: 'physician' },
        'Clinic': { property: 'clinic' },
        'Network': { property: 'network' },
        'Patient Full Name': { property: 'employee' },
        'DOB': {
            property: 'dob',
            formatDate: true
        },
        'Plan Category': { property: 'planCategoryDesc' },
        'Dependent of': { property: 'mainEmployee' },
        'Employer': { property: 'employer' },
        'Plan Effective Date': {
            property: 'planEffectiveDate',
            formatDate: true
        },
        'Coverage date': {
            property: 'coverageDate',
            formatDate: true
        },
        'Months Covered': { property: 'frequencyMonths' },
        'Year': { property: 'paymentYear' },
        'Membership Frequency': { property: 'frequency' },
        'Physician TIN': { property: 'physicianTIN' },
        'Gross Amount': {
            property: 'price',
            formatCurrency: true
        },
        'Transaction Fee': {
            property: 'accresaFee',
            formatCurrency: true
        },
        'Physician payment': {
            property: 'physicianPayment',
            formatCurrency: true
        }
    }
}

function getDebtReconciliationReportColumnMappings() {
    return {
        'Physician': { property: 'physician' },
        'Clinic': { property: 'clinic' },
        'Network': { property: 'network' },
        'Patient Full Name': { property: 'employee' },
        'DOB': {
            property: 'dob',
            formatDate: true
        },
        'Dependent of': { property: 'mainEmployee' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Employer': { property: 'employer' },
        'Collection Date': { property: 'collectionDate', formatDate: true },
        'Month': { property: 'debtMonth' },
        'Year': { property: 'debtYear'},
        'Months Covered': { property: 'frequencyMonths' },
        'Membership Frequency': { property: 'frequency' },
        'Payee': { property: 'payee' },
        'Gross Amount': {
            property: 'price',
            formatCurrency: true
        },
        'Transaction Fee': {
            property: 'accresaFee',
            formatCurrency: true
        },
        'Payment': {
            property: 'providerPayment',
            formatCurrency: true
        }
    };
}

function getDebtSettlementsReportColumnMappings() {
    return {
        'Physician': { property: 'physician' },
        'Clinic': { property: 'clinic' },
        'Network': { property: 'network' },
        'Patient Name': { property: 'patientName' },
        'DOB': {
            property: 'birthDate',
            formatDate: true
        },
        'Dependent of': { property: 'primary' },
        'Group': { property: 'group' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Collection Date': {
            property: 'collectionDate',
            formatDate: true
        },
        'Month': { property: 'month' },
        'Year': { property: 'debtYear' },
        'Months Covered': { property: 'frequencyMonths' },
        'Membership Frequency': { property: 'frequency' },
        'Amount': {
            property: 'amount',
            formatCurrency: true
        }
    }
}

function getDebtForgivenessReportColumnMappings() {
    return {
        'Physician': { property: 'physician' },
        'Clinic': { property: 'clinic' },
        'Network': { property: 'network' },
        'Patient Name': { property: 'patientName' },
        'DOB': {
            property: 'birthDate',
            formatDate: true
        },
        'Dependent Of': { property: 'primary' },
        'Group': { property: 'group' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Collection Date': {
            property: 'collectionDate',
            formatDate: true
        },
        'Month': { property: 'month' },
        'Year': { property: 'debtYear' },
        'Months Covered': { property: 'frequencyMonths' },
        'Membership Frequency': { property: 'frequency' },
        'Provider Debt': {
            property: 'providerDebt',
            formatCurrency: true
        },
        'Fees Debt': {
            property: 'feesDebt',
            formatCurrency: true
        },
        'Total Debt': {
            property: 'totalDebt',
            formatCurrency: true
        }
    }
}

function getPhysicianReportColumnMappings() {
    return {
        'Physician': { property: 'physician' },
        'Number of Patients': { property: 'numberOfPatients' },
        'Clinic': { property: 'clinic' },
        'Address': { property: 'address' },
        'City': { property: 'city' },
        'State': { property: 'state' },
        'Zip Code': { property: 'zipCode' },
        'Phone Number': {
            property: 'phoneNumber',
            formatPhone: true
        },
        'Visible in Search': {
            property: 'showInSearch',
            formatTruthy: true
        },
        'Accepting Patients': {
            property: 'acceptingNewPatients',
            formatTruthy: true
        },
        'Termination Date': {
            property: 'terminationDate',
            formatDate: true
        }
    };
}

function getPatientContractsReportColumnMappings() {
    return {
        'Patient': { property: 'patient' },
        'Dependent of': { property: 'mainConsumer' },
        'Email Address': { property: 'emailAddress' },
        'Phone Number': {
            property: 'phoneNumber',
            formatPhone: true
        }
    };
}

function getAvailablePlansReportColumnMappings() {
    return {
        'Plan Name': { property: 'planName' },
        'Plan Owner': { property: 'owner' },
        'Plan Price': {
            property: 'priceTiers',
            formatTiers: true
        },
        'Has Pending Change': {
            property: 'pendingChange',
            formatTruthy: true
        },
        'Visible': {
            property: 'display',
            formatTruthy: true
        }
    }
}

function getConsultantPaymentReportColumnMappings() {
    return {
        'Member': { property: 'employee' },
        'Dependent Of': { property: 'mainEmployee' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Individual Plan Cost': {
            property: 'individualCost',
            formatCurrency: true
        },
        'Group': { property: 'employer' },
        'Family Contribution': { property: 'familyContribution' },
        'Payment Type': { property: 'paymentMethod' },
        'State': { property: 'state' },
        'Month Covered': { property: 'monthCovered' },
        'Year': { property: 'paymentYear' },
        'Amount': {
            property: 'paymentAmount',
            formatCurrency: true
        },
        'Family Total': {
            property: 'familyTotal',
            formatCurrency: true
        }
    }
}

function getPayrollDeductionsReportColumnMappings() {
    return {
        'Member': { property: 'employee' },
        'Dependent of': { property: 'mainEmployee' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Individual Plan Cost': {
            property: 'fullMemberFee',
            formatCurrency: true
        },
        'Group': { property: 'employer' },
        'Payment Type': { property: 'paymentMethod' },
        'State': { property: 'state' },
        'Month Covered': { property: 'monthCovered' },
        'Year': { property: 'paymentYear' },
        'Amount': {
            property: 'totalWithCoverage',
            formatCurrency: true
        },
        'Family Total': {
            property: 'paymentAmount',
            formatCurrency: true
        }
    }
}

function getConsultantFeesReportColumnMappings(){
    return {
        'Group': { property: 'employer' },
        'Payment Type': { property: 'paymentMethod' },
        'Member': { property: 'familyMember' },
        'Primary Employee': { property: 'primaryEmployee' },
        'State': { property: 'state' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Fee Payer': { property: 'payer' },
        'Fee Name': { property: 'feeName' },
        'Fee Type': { property: 'feeType' },
        'Month Covered': { property: 'monthCovered' },
        'Year': { property: 'paymentYear' },
        'Amount': {
            property: 'amount',
            formatCurrency: true
        }
    }
}

function getConsultantFeePaymentsReportColumnMappings() {
    return {
        'Fee Name': { property: 'feeName' },
        'Fee Type': { property: 'feeType' },
        'Payee': { property: 'payee' },
        'Member': { property: 'member' },
        'Dependent Of': { property: 'dependentOf' },
        'Group': { property: 'group' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Physician': { property: 'physician' },
        'Coverage Date': {
            property: 'coverageDate',
            formatDate: true
        },
        'Months Covered': {
            property: 'monthsCovered',
            formatRegFeeMonthCovered: true
        },
        'Year': { property: 'paymentYear' },
        'Membership Frequency': {property: 'membershipFrequency'},
        'Gross Amount': {
            property: 'grossAmount',
            formatCurrency: true
        },
        'Transaction Fee': {
            property: 'transactionFee',
            formatCurrency: true
        },
        'Net Amount': {
            property: 'netAmount',
            formatCurrency: true
        }
    }
}

function getConsultantMemberSetupReportColumnMappings(){
    return {        
        'Primary Member ID': {
            property: 'primaryMemberId',            
        },
        'Dependent ID': {
            property: 'dependentMemberId',            
        },
        'Name': { property: 'fullName' },
        'Member Type': { property: 'memberType' },
        'Dependent Of': { 
            property: 'primaryEmployee',
            formatDependentOf: true
        },
        'Coverage Type': { 
            property: 'coverageTypeName',
            formatMemberCoverageType: true
        },
        'SetUp Complete': { property: 'setUpCompletion' },
        'Benefit Start Date': {
            property: 'effStartDate',
            formatDate: true
        },
        'Termination Date': {
            property: 'termDate',
            formatDate: true
        },
        'Auto-Renewal Date': {
            property: 'renewalDate',
            formatAutoRenewal: true
        },
        'DOB': {
            property: 'birthDate',
            formatDate: true
        },        
        'Plan Selected': {
            property: 'providerSelected',
            formatTruthy: true
        },
        'Plan Selection Date': {
            property: 'selectionDate',
            formatDate: true
        },       
        'Street Address': { 
            property: 'addressId',
            formatFullStreetAddress: true
        },
        'City': { 
            property: 'city',
        },
        'State': { 
            property: 'state',
        },
        'Zip Code': { 
            property: 'zipCode',
        },
        'Email': { 
            property: 'emailAddress',
            formatEmailForDependent: true
        },
        'Phone Number': {
            property: 'phoneNumber',
            formatPhone: true
        },
        'Group': {property: 'employer'},
        'Consumer ID': {property: 'consumerId'}
    }
}

function getGroupPaymentReportColumnMappings(){    
    return {
        'Member': { property: 'employee' },
        'Dependent Of': { property: 'mainEmployee' },
        'Individual Plan Cost': {
            property: 'individualCost',
            formatCurrency: true
        },
        'Group': { property: 'employer' },
        'Payment Type': {property: 'paymentMethod'},
        'State': { property: 'state' },
        'Month Covered': { property: 'monthCovered' },
        'Year': { property: 'paymentYear' },
        'Amount': {
            property: 'paymentAmount',
            formatCurrency: true
        },
        'Family Total': {
            property: 'familyTotal',
            formatCurrency: true
        }
    }
}

function getGroupPayrollDeductionsReportColumnMappings(){
    return {
        'Member': { property: 'employee' },
        'Dependent of': { property: 'mainEmployee' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Individual Plan Cost': {
            property: 'fullMemberFee',
            formatCurrency: true
        },
        'Group': { property: 'employer' },
        'Payment Type': {property: 'paymentMethod'},
        'State': { property: 'state' },
        'Month Covered': { property: 'monthCovered' },
        'Year': { property: 'paymentYear' },
        'Amount': {
            property: 'totalWithCoverage',
            formatCurrency: true
        },
        'Family Total': {
            property: 'paymentAmount',
            formatCurrency: true
        }
    }
}

function getGroupFeesReportColumnMappings(){
    return {
        'Group': { property: 'employer' },
        'Payment Type': {property: 'paymentMethod'},
        'Member': { property: 'familyMember' },
        'Primary Employee': { property: 'primaryEmployee' },
        'State': { property: 'state' },
        'Fee Payer': { property: 'payer' },
        'Fee Name': { property: 'feeName' },
        'Fee Type': { property: 'feeType' },
        'Month Covered': { property: 'monthCovered' },
        'Year': { property: 'paymentYear' },
        'Amount': {
            property: 'amount',
            formatCurrency: true
        }
    }
}

function getGroupDebtSettlementReportColumnMappings() {
    return {
        "Group": { property: "group" },
        "Consultant": {property: "consultant"},
        "Payment Type": { property: "paymentMethod" },
        "Fee Name": { property: "feeName" },
        "Fee Type": { property: "feeType" },
        "Member Count": { property: "memberCount" },
        "Fee Payer": { property: "payer" },
        "Collection Date": { property: "collectionDate", formatDate: true },
        "Month": { property: "month" },
        "Year": { property: "year" },
        "Amount":{ property: "amount", formatCurrency: true },
    }
}

function getGroupDebtReconcilationReportColumnMappings() {
    return {
        "Group": { property: "group" },
        "Consultant": {property: "consultant"},
        "Member": { property: "familyMember" },
        "Primary Employee": { property: "primaryEmployee" },
        "Fee Name": { property: "feeName" },
        "Fee Type": { property: "feeType" },
        "Fee Payer": { property: "payer" },
        "Payment Type": { property: "paymentMethod" },
        "Provider Payee":{ property: "providerPayee" },
        "External Payee":{ property: "externalPayee" },
        "Month":{ property: "paymentMonth" },
        "Year":{ property: "year" },
        "Gross Amount":{ property: "grossAmount", formatCurrency: true },
        "Transaction Fee":{ property: "transactionFee", formatCurrency: true },
        "Payment":{ property: "payment", formatCurrency: true },
    }
}

function getGroupMemberSetupReportColumnMappings(){
    return {
        'Primary Member ID': {
            property: 'primaryMemberId',            
        },
        'Dependent ID': {
            property: 'dependentMemberId',            
        },
        'Name': { property: 'fullName' },
        'Member Type': { property: 'memberType' },
        'Dependent Of': { 
            property: 'primaryEmployee',
            formatDependentOf: true
        },
        'Coverage Type': { 
            property: 'coverageTypeName',
            formatMemberCoverageType: true
        },
        'SetUp Complete': { property: 'setUpCompletion' },
        'Benefit Start Date': {
            property: 'effStartDate',
            formatDate: true
        },
        'Termination Date': {
            property: 'termDate',
            formatDate: true
        },
        'Auto-Renewal Date': {
            property: 'renewalDate',
            formatAutoRenewal: true
        },
        'DOB': {
            property: 'birthDate',
            formatDate: true
        },        
        'Plan Selected': {
            property: 'providerSelected',
            formatTruthy: true
        },
        'Plan Selection Date': {
            property: 'selectionDate',
            formatDate: true
        },
        'Street Address': { 
            property: 'addressId',
            formatFullStreetAddress: true
        },
        'City': { 
            property: 'city',
        },
        'State': { 
            property: 'state',
        },
        'Zip Code': { 
            property: 'zipCode',
        },
        'Email': { 
            property: 'emailAddress',
            formatEmailForDependent: true
        },
        'Phone Number': {
            property: 'phoneNumber',
            formatPhone: true
        },
        'Group': {property: 'employer'},
        'Consumer ID': {property: 'consumerId'}
    }
}

function getAutoEnrollmentReportColumnMappings(){
    return {
        'Participant Name': { property: 'participantName'},
        'Participant Id': { property: 'participantId'},
        'Error': { property: 'error'},
        'Date': { 
            property: 'createdAt',
            formatDate: true        
        }
    }
}

function getAdminEmployerContributionPaymentReportColumnMappings(){    
    return {
        'Member': { property: 'employee' },
        'Dependent Of': { property: 'mainEmployee' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Individual Plan Cost': {
            property: 'individualCost',
            formatCurrency: true
        },
        'Group': { property: 'employer' },
        'Family Contribution': { property: 'familyContribution' },        
        'Consultant': {property: 'consultant'},
        'Payment Type': {property: 'paymentMethod'},
        'State': { property: 'state' },
        'Month Covered': { property: 'monthCovered' },
        'Year': { property: 'paymentYear' },
        'Amount': {
            property: 'paymentAmount',
            formatCurrency: true
        },
        'Family Total': {
            property: 'familyTotal',
            formatCurrency: true
        }
    }
}

function getAdminFeesReportColumnMappings(){    
    return {
        'Group':{property: 'employer'},
        'Consultant':{property: 'consultant'},
        'Payment Type': {property: 'paymentMethod'},
        'Member': { property: 'familyMember' },
        'Primary Employee': { property: 'primaryEmployee' },
        'State': { property: 'state' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Fee Name': { property: 'feeName' },
        'Fee Type': { property: 'feeType' },
        'Month Covered': { property: 'monthCovered' },
        'Year': { property: 'paymentYear' },
        'Fee Payer': { property: 'payer' },
        'Amount': {
            property: 'amount',
            formatCurrency: true
        }        
    }
}

function getAdminParticipantsReportColumnMappings(){
    return {
        'Member Name': { property: 'employee' },
        'Dependent Of': { property: 'mainEmployee' },
        'Member Id': { property: 'consumerId' },
        'Group':{property: 'employer'},
        'Plan Category': { property: 'planCategoryDesc' },
        'Months Covered': { property: 'frequencyMonths' },
        'Year': { property: 'paymentYear' },
        'Membership Frequency': { property: 'frequency' },                
        'Amount': {
            property: 'totalWithCoverage',
            formatCurrency: true
        },
        'Original Amount': {
            property: 'originalAmount',
            formatCurrency: true
        },
        'Family Total': {
            property: 'paymentAmount',
            formatCurrency: true
        }        
    }
}

function getAdminPayrollDeductionsReportColumnMappings(){
    return {
        'Member': { property: 'employee' },
        'Dependent of': { property: 'mainEmployee' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Individual Plan Cost': {
            property: 'fullMemberFee',
            formatCurrency: true
        },
        'Group': { property: 'employer' },
        'Consultant': {property: 'consultant'},
        'Payment Type': {property: 'paymentMethod'},
        'State': { property: 'state' },
        'Month Covered': { property: 'monthCovered' },
        'Year': { property: 'paymentYear' },
        'Amount': {
            property: 'totalWithCoverage',
            formatCurrency: true
        },
        'Family Total': {
            property: 'paymentAmount',
            formatCurrency: true
        }
    }
}

function getAdminPhysicianPaymentsReportColumnMappings(){
    return {
        'Physician': { property: 'physician' },
        'Clinic': { property: 'clinic' },
        'Network': { property: 'network' },
        'Patient Full Name': { property: 'employee' },
        'Dependent Of': { property: 'mainEmployee' },
        'Plan Category': { property: 'planCategoryDesc' },
        'DOB': { 
            property: 'dob',
            formatDate: true
         },
        'Employer': { property: 'employer' },
        'Effective Date': {
            property: 'planEffectiveDate',
            formatDate: true
        },
        'Coverage Date': {
            property: 'coverageDate',
            formatDate: true
        },
        'Months Covered': { property: 'frequencyMonths' },
        'Year': { property: 'paymentYear' },
        'Membership Frequency': { property: 'frequency' },
        'Price': {
            property: 'price',
            formatCurrency: true
        }, 
        'Gross Amount': {
            property: 'grossAmount',
            formatCurrency: true
        },
        'Transaction Fee': {
            property: 'accresaFee',
            formatCurrency: true
        },
        'Physician Payment': {
            property: 'physicianPayment',
            formatCurrency: true
        }
    }
}

function getAdminStackedFeesReportColumnMappings(){
    return {
        'Physician': { property: 'physician' },
        'Patient Full Name': { property: 'employee' },
        'Dependent Of': { property: 'mainEmployee' },
        'Employer': { property: 'employer' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Coverage Date': {
            property: 'coverageDate',
            formatDate: true
        },
        'Months Covered': { property: 'frequencyMonths' },
        'Year': { property: 'paymentYear' },
        'Membership Frequency':{ property: 'frequency'},
        'Fee Name': { property: 'feeName' },        
        'Fee Type': { property: 'feeType' },        
        'Payee': { property: 'payee' },           
        'Price': {
            property: 'price',
            formatCurrency: true
        },                        
        'Gross Amount': {
            property: 'grossAmount',
            formatCurrency: true
        },        
        'Transaction Fee': {
            property: 'accresaFee',
            formatCurrency: true
        },
        'Amount': {
            property: 'amount',
            formatCurrency: true
        }
    }
}

function getAdminNonStackedFeesReportColumnMappings(){
    return {
        'Patient Full Name': { property: 'familyMember' },
        'Dependent Of': { property: 'primaryEmployee' },
        'Employer': { property: 'employer' },
        'Consultant': { property: 'consultant'},
        'Payment Type': {property: 'paymentMethod'},
        'Fee Name': { property: 'feeName' },        
        'Fee Type': { property: 'feeType' },        
        'Month Covered': { property: 'monthCovered' },
        'Year': { property: 'paymentYear' },
        'Fee Payer': { property: 'payer' },               
        'Fee Payee': { property: 'payee' },               
        'Gross Amount': {
            property: 'amount',
            formatCurrency: true
        },        
        'Net Amount': {
            property: 'paymentAmount',
            formatCurrency: true
        }
    }
}

function getAdminRetailMembershipReportColumnMappings(){
    return {
        'Provider Name': { property: 'providerName' },        
        'Package Name': { property: 'packageName'},
        'Package Cost': { property: 'packageCost'},
        'Package Frequency': { property: 'packageFrequency'},
        'Registration Date': {
            property: 'registrationDate',
            formatDate: true
        },
        'Current Membership Start Date': {
            property: 'currentMembershipStartDate',
            formatDate: true
        },
        'Renewal Date': { 
            property: 'renewalDate',
            formatDate: true
        },
        'Renewal Cost': { property: 'renewalCost' },
        'Renewal Frequency': { property: 'renewalFrequency' },
        'Email': { property: 'emailAddress'},
        'Days Behind': { property: 'daysBehind'}
    }
}

function getAdminDebtReconciliationReportColumnMappings(){
    return {
        'Physician': { property: 'physician' },
        'Clinic': { property: 'clinic' },
        'Network': { property: 'network' },
        'Patient Full Name': { property: 'employee' },
        'DOB': {
            property: 'dob',
            formatDate: true
        },
        'Dependent Of': { property: 'mainEmployee' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Employer': { property: 'employer' },
        'Fee Name': { property: 'feeName' },
        'Fee Type': { property: 'feeType' },
        'Collection Date': { property: 'collectionDate', formatDate: true },
        'Month': { property: 'debtMonth' },
        'Year': { property: 'debtYear'},
        'Months Covered': { property: 'frequencyMonths' },
        'Membership Frequency': { property: 'frequency' },        
        'Gross Amount': {
            property: 'price',
            formatCurrency: true
        },
        'Transaction Fee': {
            property: 'accresaFee',
            formatCurrency: true
        },
        'Payment': {
            property: 'providerPayment',
            formatCurrency: true
        },
        'Provider Payee': { property: 'payee' },
        'External Payee': { property: 'externalPayee' },
    };
}

function getPSRTelescopeDCPPatientsColumnMappings() {
    return {
        'Member': { property: 'member' },
        'Dependent of': { property: 'dependent' },
        'Gender' : {property: 'gender'},
        'DOB': {
            property: 'birthDate',
            formatDate: true
        },
        'Plan Start Date': {
            property: 'effectiveDate',
            formatDate: true
        },
        'Plan End Date': {
            property: 'endDate',
            formatDate: true
        },
        'Group': { property: 'group' },
        'Network': { property: 'network' },
        'Phone Number': {
            property: 'phoneNumber',
            formatPhone: true
        },
        'Email Address': { property: 'emailAddress' },
        'Address': {
            property: 'address',
            formatAddress: true
        },
        'City, State': {
            property: 'address',
            formatCityState: true
        }
    }
}

function getInvoicePaymentReportColumnMappings() {
    return {
        'Created Date': {
            property: 'createdDate',
            formatDate: true
        },
        'Invoice ID': { property: 'invoiceId' },
        "Line Item ID": { property: "lineItemId"},
        "Item": { property: "title"},
        "Payer": { property: "payor"},
        "Payer Entity Type": { property: "payorEntityType"},
        "Payer Payment Type": { property: "payorPaymentType"},
        "Payee": { property: "payee"},
        'Payment Date': {
            property: 'paymentDate',
            formatDate: true
        },
        'Gross Amount': {
            property: 'grossAmount',
            formatCurrency: true
        },
        'Transaction Fee': {
            property: 'transactionFee',
            formatCurrency: true
        },
        'Amount': {
            property: 'paymentAmount',
            formatCurrency: true
        },
    }
}

function getFeeBundleReportColumnMappings(){
    return {
        'Group Name': { property: 'groupName' },
        "AMF Code": { property: "amfCode"},
        "Fee Name": { property: "feeName"},
        "Offering Name": { property: "offeringName" },
        "Benefit Eligible": { property: "benefitEligible"},
        'Gross Amount': {
            property: 'grossAmount',
            formatCurrency: true
        },
        'Transaction Fee': {
            property: 'transactionFee',
            formatCurrency: true
        },
        'Payment Net': {
            property: 'paymentNet',
            formatCurrency: true
        },
    }
}

function getContributionSettlementReportColumnMappings(){
    return {
        "Group": { property: "group" },
        "Consultant": { property: "consultant"},
        "Payment Method": { property: "paymentMethod" },
        "Member Count": { property: "memberCount" },
        "Collection Date": { property: "collectionDate", formatDate: true },
        "Month": { property: "month" },
        "Year": { property: "year" },
        "Amount":{ property: "amount", formatCurrency: true },
    }
}

function getAdminDebtReconciliationContributionReportColumnMappings(){
    return {
        'Physician': { property: 'physician' },
        'Clinic': { property: 'clinic' },
        'Network': { property: 'network' },
        'Patient Full Name': { property: 'employee' },
        'DOB': {
            property: 'dob',
            formatDate: true
        },
        'Dependent of': { property: 'mainEmployee' },
        'Employer': { property: 'employer' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Month': { property: 'debtMonth' },
        'Year': { property: 'debtYear'},
        'Months Covered': { property: 'frequencyMonths' },
        'Membership Frequency': { property: 'frequency' },
        'Provider Payee': { property: 'providerPayee' },
        'External Payee': { property: 'externalPayee' },
        'Payment Type': {property: 'paymentType'},
        'Gross Amount': {
            property: 'price',
            formatCurrency: true
        },
        'Transaction Fee': {
            property: 'accresaFee',
            formatCurrency: true
        },
        'Payment': {
            property: 'providerPayment',
            formatCurrency: true
        }
    };
}

function getAdminPayrollSettlementReportColumnMappings(){
    return {
        "Group": { property: "group" },
        "Consultant": { property: "consultant"},
        "Payment Method": { property: "paymentMethod" },
        "Member Count": { property: "memberCount" },
        "Collection Date": { property: "collectionDate", formatDate: true },
        "Month": { property: "month" },
        "Year": { property: "year" },
        "Amount":{ property: "amount", formatCurrency: true }
    } 
}

function getAdminPayrollReconciliationReportColumnMappings(){
    return {
        "Group": {property: "group"},
        "Consultant": {property: "consultant"},
        "Patient Full Name": {property: "employee"},
        "Dependent of": {property: "mainEmployee"},
        "Plan Category": {property: "planCategoryDesc"},
        "Payment Type": {property: "paymentType"},
        "Provider Payee": {property: "providerPayee"},
        "External Payee": {property: "externalPayee"},
        "Month Covered": {property: "frequencyMonths"},
        "Year": {property: "debtYear"},
        "Gross Amount": {property: "grossAmount", formatCurrency: true},
        "Transaction Fee": {property: "transactionFee", formatCurrency: true},
        "Payment": {property: "payment", formatCurrency: true}
    }
}

function getAdminGeneratedNachaLineItemReportColumnMappings(){
    return {
        "ItemId": { property: "itemId" },
        "Payee Name": { property: "payeeName"},
        "Amount":{ property: "amount", formatAbsValueCurrency: true },
        "Type": { property: "type"},
        "Reason": { property: "reason" },
        "Created Date": { property: "createdDate"}
    } 
}

function getAdminConsumerRefundsReportColumnMappings(){
    return {
        'Member Name': { property: 'fullName' },
        'ConsumerId': { property: 'consumerId' },
        'DOB': { property: 'birthDate', formatDate: true },
        'Group': { property: 'groupName' },
        'Month': { property: 'month' },
        'PaymentId': { property: 'paymentRecordId' },
        'Paid': { property: "paidDate", formatDate: true },
        'Refunded': { property: "refundDate", formatDate: true },
        'Amount' : { property: 'paymentAmount', formatCurrency: true},
    }
}

function getGroupParticipantsReportColumnMappings(){
    return {
        'Member Name': { property: 'employee' },
        'Dependent Of': { property: 'mainEmployee' },
        'Member Id': { property: 'consumerId' },
        'Plan Category': { property: 'planCategoryDesc' },
        'Months Covered': { property: 'frequencyMonths' },
        'Year': { property: 'paymentYear' },
        'Membership Frequency': { property: 'frequency' },                
        'Amount': {
            property: 'totalWithCoverage',
            formatCurrency: true
        },
        'Family Total': {
            property: 'paymentAmount',
            formatCurrency: true
        }        
    }
}

function getConsultantReferralReportColumnMappings() {
    return {
        'Full Name': { property: 'fullName' },
        'Gender': { property: 'genderCode' },
        'Phone Number': {
            property: 'phoneNbr',
            formatPhone: true
        },
        'DOB': {
            property: 'birthDate',
            formatDate: true
        },
        'Email': { property: 'emailAddress' },
        'Address': { property: 'address' },
        'Group': { property: 'groupName' },
        'Answer': { property: 'answer' },
        'Business Owner': { property: 'isBusinessOwner' },
        'Wants Employee Services Info': { property: 'wantsEmployeeServicesInfo' }
    }
}